import {
  jb_bypass_block_css_default
} from "./chunk.AXY4FEVD.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-bypass-block/jb-bypass-block.ts
var JbBypassBlock = class extends i {
  constructor() {
    super(...arguments);
    this._itemMapByHotkey = /* @__PURE__ */ new Map();
    this._itemMapByName = /* @__PURE__ */ new Map();
  }
  update(changedProperties) {
    super.update(changedProperties);
    if (!changedProperties.has("items")) return;
    this._itemMapByHotkey = new Map(
      this.items.filter((item) => item.hotkey).map((item) => [this._normalizeHotkey(item.hotkey), item])
    );
    this._itemMapByName = new Map(this.items.map((item) => [item.name, item]));
  }
  _findFirstTextNode(root) {
    return Array.from(root.childNodes).reduce((found, node) => {
      if (found) return found;
      if (node.nodeType === Node.TEXT_NODE && node.data.trim()) return node;
      if (node.nodeType === Node.ELEMENT_NODE)
        return this._findFirstTextNode(node.shadowRoot ?? node);
      return null;
    }, null);
  }
  _handleBypass(bypassItemName) {
    const bypassItem = this._itemMapByName.get(bypassItemName);
    if (!bypassItem) return;
    if (bypassItem.href) {
      if (bypassItem.href.startsWith("#")) {
        const target = document.querySelector(bypassItem.href);
        if (target) {
          const textNode = this._findFirstTextNode(target.shadowRoot ?? target);
          const focusTarget = textNode?.parentElement ?? target;
          if (!focusTarget.hasAttribute("tabindex")) {
            focusTarget.setAttribute("tabindex", "-1");
          }
          setTimeout(() => focusTarget.focus(), 0);
          return;
        }
      }
      window.location.href = bypassItem.href;
      return;
    }
    this.dispatchEvent(
      new CustomEvent("jb-bypass-block:navigate", {
        detail: { name: bypassItem.name, hotkey: bypassItem.hotkey },
        bubbles: true,
        composed: true
      })
    );
  }
  _handleClick(evt) {
    const itemName = evt.target.dataset.name;
    if (itemName) this._handleBypass(itemName);
  }
  _handleKeyDown(evt) {
    if (evt.code === "Space") {
      evt.preventDefault();
      evt.target.click();
      return;
    }
    const key = this._normalizeHotkey(evt.key);
    if (this._itemMapByHotkey.has(key)) {
      this._handleBypass(this._itemMapByHotkey.get(key).name);
    }
  }
  _normalizeHotkey(key) {
    return `key${key.toUpperCase()}`;
  }
  _renderItem(item) {
    const content = b`${item.label} ${item.hotkey ? `[${item.hotkey}]` : A}`;
    return item.href && !item.href.startsWith("#") ? b`<a
          aria-label="${item.label}"
          data-name="${item.name}"
          data-hotkey="${item.hotkey ?? ""}"
          href="${item.href}"
          @click=${this._handleClick}
          @keydown=${this._handleKeyDown}
          >${content}</a
        >` : b`<button
          aria-label="${item.label}"
          data-name="${item.name}"
          data-hotkey="${item.hotkey ?? ""}"
          @click=${this._handleClick}
          @keydown=${this._handleKeyDown}
        >
          ${content}
        </button>`;
  }
  render() {
    return b`<div class="bypass-block">${this.items.map((item) => this._renderItem(item))}</div>`;
  }
};
JbBypassBlock.styles = [reset_css_default, jb_bypass_block_css_default];
__decorateClass([
  n({ type: Array })
], JbBypassBlock.prototype, "items", 2);
JbBypassBlock = __decorateClass([
  customElement("jb-bypass-block")
], JbBypassBlock);

export {
  JbBypassBlock
};
